export default function getMemberCarrierInvoiceParams() {
  if (Number(window.localStorage["memberCarrierType"]) !== 1) {
    return {};
  }

  return {
    VehicleType: 4,
    VehicleTypeNumber: "EG0883",
  };
}
